export enum ResultReportStatusColor {
  NotKnown = '#959393',
  NotYet = '#4C8699',
  NotAchieved = '#CC3333',
  PartiallyAchieved = '#DDBA00',
  OnTrack = '#A6D4A5',
  Achieved = '#037429',
  NoLongerRelevant = '#959393',
}
